import { useState } from "react";

interface AccessCodeModalProps {
  onSubmit: (code: string) => void;
  loading: boolean;
  error?: string | null;
  linkName?: string;
}

export function AccessCodeModal({
  onSubmit,
  loading,
  error,
  linkName,
}: AccessCodeModalProps) {
  const [accessCode, setAccessCode] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (accessCode.trim()) {
      onSubmit(accessCode);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <i className="ri-lock-line text-3xl text-amber-600"></i>
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            Acceso Protegido
          </h1>
          {linkName && (
            <p className="text-gray-600 text-sm mb-2">
              {linkName}
            </p>
          )}
          <p className="text-gray-500 text-sm">
            Este link de seguimiento requiere un código de acceso para visualizar
            las unidades.
          </p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label
              htmlFor="accessCode"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Código de Acceso
            </label>
            <input
              type="password"
              id="accessCode"
              value={accessCode}
              onChange={(e) => setAccessCode(e.target.value)}
              placeholder="Ingresa el código de acceso"
              className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 transition-all ${
                error
                  ? "border-red-500 focus:ring-red-500"
                  : "border-gray-300"
              }`}
              disabled={loading}
              autoFocus
            />
            {error && (
              <p className="mt-2 text-sm text-red-600 flex items-center gap-1">
                <i className="ri-error-warning-line"></i>
                {error}
              </p>
            )}
          </div>

          <button
            type="submit"
            disabled={loading || !accessCode.trim()}
            className={`w-full py-3 px-4 rounded-lg font-medium transition-all flex items-center justify-center gap-2 ${
              loading || !accessCode.trim()
                ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                : "bg-primary-500 hover:bg-primary-400 text-gray-900"
            }`}
          >
            {loading ? (
              <>
                <div className="w-5 h-5 border-2 border-gray-400 border-t-transparent rounded-full animate-spin"></div>
                <span>Verificando...</span>
              </>
            ) : (
              <>
                <i className="ri-login-circle-line"></i>
                <span>Acceder</span>
              </>
            )}
          </button>
        </form>

        {/* Footer */}
        <div className="mt-8 pt-6 border-t border-gray-200">
          <p className="text-xs text-gray-400 text-center">
            Si no conoces el código de acceso, contacta a la persona que te
            compartió este link.
          </p>
        </div>
      </div>
    </div>
  );
}
